// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q9i0","label":"styles_label__35znm"};